//Custom components
import StatCard from '../../../UI/Card/StatCard';

const AverageProjectBudget = ({ count }: { count: number | string }) => {
  return <StatCard title='Average Project Budget' stat={`$ ${count}`} />;
};

export default AverageProjectBudget;
